import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "advice-details-actions" }
const _hoisted_2 = { class: "mr-auto order-1 md:mr-auto" }
const _hoisted_3 = { class: "button__icon" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "block md:inline-block md:mr-2" }, "Pobierz fakturę", -1)
const _hoisted_5 = { class: "order-2 md:order-3" }
const _hoisted_6 = { class: "button__icon" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "block md:inline-block md:mr-2" }, " Dodaj fakturę ", -1)
const _hoisted_8 = { class: "order-3 md:mr-4 md:order-2" }
const _hoisted_9 = { class: "button__icon" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "block md:inline-block md:mr-2" }, " SMS do kierowcy ", -1)

import { ref, computed } from 'vue'
import { UiMobileFixedFooter, UiButton } from '@/components/common/ui'
import { useNotifications } from '@/composables/useNotifications'
import { useAdvices, AdviceDetails } from '@/composables/useAdvices'
import { useInvoices } from '@/composables/useInvoices'
import router from '@/router'
import { useAdviceDocuments } from '@/composables/useAdviceDocuments'

type Props = {
    adviceDetails: AdviceDetails
}

export default /*#__PURE__*/_defineComponent({
  props: {
    adviceDetails: { type: null, required: true }
  },
  setup(__props: any) {

const props = __props as {
    adviceDetails: AdviceDetails
}


const { pushSuccess, pushFail } = useNotifications()
const { addAdviceToStorage, removeAllSelectedAdvicesFromStorage } = useAdviceDocuments()

const canSendSms = computed(() => !!props.adviceDetails.driverPhone)

const { sendSmsToDriver } = useAdvices()
const isSendingSms = ref<boolean>(false)
const handleSendSmsAction = async () => {
    isSendingSms.value = true
    try {
        await sendSmsToDriver(props.adviceDetails.id)
        pushSuccess('Sms wysłany poprawnie')
    } catch {
        pushFail('Sms nie został wysłany')
    } finally {
        isSendingSms.value = false
    }
}

const { downloadInvoice, isDownloadingInvoiceFile } = useInvoices()
const handleDownloadInvoice = () => {
    const { id, filename, filenamePdf } = props.adviceDetails.carrierInvoices[0]
    downloadInvoice(id, filename || (filenamePdf && filenamePdf.split('.')[0]))
}
const hasInvoice = computed(() => props.adviceDetails.carrierInvoices.length !== 0)
const adviceDelivered = computed(() => props.adviceDetails.adviceStatus.symbol === 'delivered')
const adviceVerified = computed(() => props.adviceDetails.adviceStatus.symbol === 'verified')

const addInvoiceHandler = async () => {
    await removeAllSelectedAdvicesFromStorage()
    await addAdviceToStorage(props.adviceDetails)
    router.push({ name: 'add-invoice' })
}

return (_ctx: any,_cache: any) => {
  const _component_IconDownload = _resolveComponent("IconDownload")!
  const _component_IconCrossDark = _resolveComponent("IconCrossDark")!
  const _component_IconCross = _resolveComponent("IconCross")!
  const _component_IconMessage = _resolveComponent("IconMessage")!

  return (_openBlock(), _createBlock(_unref(UiMobileFixedFooter), null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_unref(hasInvoice))
            ? (_openBlock(), _createBlock(_unref(UiButton), {
                key: 0,
                loading: _unref(isDownloadingInvoiceFile),
                outline: "",
                class: "advice-details-actions__button",
                onClick: handleDownloadInvoice
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_IconDownload)
                  ]),
                  _hoisted_4
                ]),
                _: 1
              }, 8, ["loading"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_5, [
          (!_unref(hasInvoice) && (_unref(adviceDelivered) || _unref(adviceVerified)))
            ? (_openBlock(), _createBlock(_unref(UiButton), {
                key: 0,
                class: "advice-details-actions__button advice-details-actions__button--act-as-primary",
                onClick: addInvoiceHandler
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_IconCrossDark, { class: "block md:hidden" }),
                    _createVNode(_component_IconCross, { class: "hidden md:block" })
                  ]),
                  _hoisted_7
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_unref(UiButton), {
            outline: "",
            loading: isSendingSms.value,
            disabled: !_unref(canSendSms),
            "show-tooltip": !_unref(canSendSms),
            "tooltip-message": "Brak numeru telefonu do kierowcy",
            class: "advice-details-actions__button",
            onClick: handleSendSmsAction
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_IconMessage)
              ]),
              _hoisted_10
            ]),
            _: 1
          }, 8, ["loading", "disabled", "show-tooltip"])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})